export default {
      id: "play-usage",
      viewBox: "0 0 11 14",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#play",
      toString: function () {
        return this.url;
      }
    }